export default function EarningsPage() {
  return <div style={{ padding: 30 }}><h1>Earnings</h1><p>Coming soon...</p></div>;
}
